export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_FULFILLED = 'ADD_TO_CART_FULFILLED';
export const ADD_TO_CART_REJECTED = 'ADD_TO_CART_REJECTED';

